import type { Theme } from '@hivebrite/design-system/Theme';

import getListColors from './getListColors';

const getPresetColors = ({
  type,
  theme,
  brandColors,
}: {
  type?: string;
  theme: Theme;
  brandColors?: { label: string; value: string }[];
}) =>
  getListColors({
    withTransparent: type === 'BackgroundColor',
    theme,
    brandColors,
  });

export default getPresetColors;
